import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppCommonModule } from './common/modules/appcommon.module';
import { AppComponentModule } from './common/modules/appcomponent.module';
import { DialogHelperModule, LoadingOverlayModule, HttpHelperModule } from 'nglhelper';
import { FormHelper } from './common/FormHelper';
//import { AvatarComponent } from './common/components/avatar/avatar.component';

import { ToastyModule } from 'ng2-toasty';
import { TreeModule } from 'ng2-tree';
import { VerticalTimelineModule } from 'angular-vertical-timeline';
import { FormLoader } from './common/services/formloader';
import { LayoutService } from './common/services/layoutservice';
import { AuthService } from './common/services/authservice';
import { CompanyShellService } from './common/services/companyshellservice';
import { ActionProviderService } from './common/services/actionproviderservice';
import { EmailValidatorService } from './common/services/emailvalidatorservice';
import { IsLoginGuard } from './common/authguard/isloginguard';

//Component
import { AppComponent } from './app.component';
import { AppShellComponent } from './appshell.component';
import { AppFormModule } from './common/modules/appform.module';
import { SiteMapComponent } from './sitemap.component';
import { LoginComponent } from './accounts/login/login.component';
import { AccessDeniedComponent } from './accounts/accesdenied/accessdenied.component';
import { ChangePasswordComponent } from './accounts/changepassword/changepassword.component';

var routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/login' },
  { path: 'login', component: LoginComponent },
  { path: 'changepassword', canActivate: [IsLoginGuard], component: ChangePasswordComponent },
  { path: 'sysadmin', loadChildren: () => import('./sysadmin/sysadmin.module').then(m => m.SysAdminModule) },
  {
    path: '', component: AppShellComponent, canActivate: [IsLoginGuard], canActivateChild: [IsLoginGuard], children: [
      { path: 'sitemap', component: SiteMapComponent },
      { path: 'accessdenied', component: AccessDeniedComponent },
      { path: 'staff', loadChildren: () => import('./staff/staff.module').then(m => m.StaffModule) },
      { path: 'company', loadChildren: () => import('./company/company.module').then(m => m.CompanyModule) },
      { path: 'asset', loadChildren: () => import('./asset/asset.module').then(m => m.AssetModule) },
      { path: 'action', loadChildren: () => import('./action/action.module').then(m => m.ActionModule) },
      { path: 'process', loadChildren: () => import('./process/process.module').then(m => m.ProcessModule) },
      { path: 'workorder', loadChildren: () => import('./workorder/workorder.module').then(m => m.WorkOrderModule) },
      { path: 'report', loadChildren: () => import('./report/report.module').then(m => m.ReportModule) },
      { path: 'administrative', loadChildren: () => import('./administrative/administrative.module').then(m => m.AdministrativeModule) },
      { path: 'guidebook', loadChildren: () => import('./guidebook/guidebook.module').then(m => m.GuideBookModule) },
    ]
  }
]

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    AppShellComponent,
    AccessDeniedComponent,
    SiteMapComponent,
    //AvatarComponent,
    ChangePasswordComponent
  ],

  imports: [
    BrowserAnimationsModule,
    AppCommonModule,
    AppComponentModule,
    AppFormModule,
    TreeModule,
    BrowserModule,
    DialogHelperModule,HttpHelperModule,LoadingOverlayModule,
    VerticalTimelineModule,
    ToastyModule.forRoot(),
    RouterModule.forRoot(routes),
    //HttpLoaderModule.forRoot(),
    //HttpHelperModule.forRoot(),
    //HttpJwtModule.forRoot(),
    //DialogHelperModule.forRoot(),
    //DropDownsModule, PanelBarModule,
    //LoadingWindowModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [FormHelper, FormLoader, AuthService, IsLoginGuard, LayoutService, CompanyShellService, ActionProviderService, EmailValidatorService],
  bootstrap: [AppComponent]
})
export class AppModule { }
